<div>
      <div class="grid mt-2">
        <div class="col-12 grid flex flex-row align-items-end pb-0">
          <div class="col-12 md:col-4 p-fluid flex flex-column">
            <span for="stockSelect" class="text-xs">
              {{'AssignStock.StockLabel' | translate}}
            </span>
            <p-dropdown
              #stockSelect
              [options]="stock"
              optionLabel="name"
              [(ngModel)]="stockId"
              placeholder="Stock"
              (onChange)="getPalletStock()"
              optionValue="id"
              class="custom-dropdown w-full"/>
          </div>
          <div class="col-12 md:col-4 p-fluid flex flex-column">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInput
                pInputText
                placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}"
                class="custom-input w-full"
                [(ngModel)]="searchTerm"
                (input)="configFilterSearch()" />
            </span>
          </div>
          <div  class="col-12 md:col-2 p-fluid flex flex-column">
                <p-button
                label="Buscar"
                (click)="searchPalletStock()"
                class="custom-text-button"
                [loading]="loading"/>
          </div>
        </div>
        <div class="col-12 p-fluid flex flex-column lg:flex-row justify-content-start gap-2">
          <div class="col-12 lg:col-5 border-div">
            <span class="text-xs">{{'AssignStock.FilterLabel' | translate}}</span>
            <div class="flex justify-content-start pt-2">
              <app-filter-pallet-stock
                [loading]="loading"
                [stockId]="stockId"
                (applyFilterEvent)="configFilter($event)"/>
            </div>
          </div>
          <div class="flex flex-row col-12 p-0 gap-2">
            <div class="col-6 lg:col-3 border-div">
              <span class="text-xs">{{'AssignStock.Group' | translate}}</span>
              <div class="flex flex-wrap w-12 pt-2">
                <div class="flex w-6 align-items-center pb-2">
                    <p-checkbox (onChange)="changeGroup()" [(ngModel)]="withPalletNumber" inputId="withCategory" name="withCategory" [binary]="true"  size="small" />
                    <label for="withPalletNumber" class="ml-1 text-sm">{{'AssignStock.PalletNumberLabel' | translate}}</label>
                </div>
                <div class="flex w-6 align-items-center pb-2">
                    <p-checkbox (onChange)="changeGroup()" [(ngModel)]="withCategory" inputId="withCategory" name="withCategory" [binary]="true"  size="small" />
                    <label for="withCategory" class="ml-1 text-sm">{{'AssignStock.CategoryLabel' | translate}}</label>
                </div>
                <div class="flex w-6 align-items-center py-2">
                    <p-checkbox (onChange)="changeGroup()" [(ngModel)]="withSpeciesSize" inputId="withSpeciesSize" name="withSpeciesSize" [binary]="true"  size="small" />
                    <label for="withSpeciesSize" class="ml-1 text-sm">{{'AssignStock.SpeciesSizeLabel' | translate}}</label>
                </div>
                <div class="flex w-6 align-items-center py-2">
                    <p-checkbox (onChange)="changeGroup()" [(ngModel)]="withProducer" inputId="withProducer" name="withProducer" [binary]="true"  size="small" />
                    <label for="withProducer" class="ml-1 text-sm">{{'AssignStock.ProducerLabel' | translate}}</label>
                </div>
                <div class="flex w-6 align-items-center py-2">
                    <p-checkbox (onChange)="changeGroup()" [(ngModel)]="withProgramName" inputId="withProgramName" name="withProgramName" [binary]="true"  size="small" />
                    <label for="withProgramName" class="ml-1 text-sm">{{'AssignStock.ProgramNameLabel' | translate}}</label>
                </div>
              </div>
            </div>
            <div class="col-6 lg:col-4" style="padding: 0;">
              <div class="col-12 flex align-items-center align-content-center" style="padding: 0;">
                <div class="col-6 pl-0 pt-0">
                  <div class="stat-vertical">
                    <span class="stat-title">
                    {{'AssignStock.TotalCases' | translate}}
                    </span>
                    <span class="stat-number">
                      {{totalCases}}
                    </span>
                  </div>
                </div>
                <div class="col-6 pt-0">
                  <div class="stat-vertical">
                    <span class="stat-title">
                      {{'AssignStock.TotalPallets' | translate}}
                    </span>
                    <span  class="stat-number">
                      {{uniquePalletStock}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 flex justify-content-start" style="padding: 0;">
                <div class="col-6 pl-0 pb-0">
                  <div class="stat-vertical-select">
                    <span class="stat-title">
                    {{'AssignStock.CasesSelected' | translate}}
                    </span>
                    <span  class="stat-number">
                      {{totalCasesSelected}}
                    </span>
                  </div>
                </div>
                <div class="col-6 pb-0">
                  <div class="stat-vertical-select">
                    <span class="stat-title">
                    {{'AssignStock.PallesSelected' | translate}}
                    </span>
                    <span  class="stat-number">
                      {{uniquePalletStockSelected.length}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4 w-full">
        <p-table
        #palletStockTable
        [value]="groupPalletStock"
        class="custom-table stock-table"
        dataKey="groupIndex"
        (onLazyLoad)="getPalletStockPaged($event)"
        [paginator]="groupPalletStock.length ? true : false"
        [rows]="pageSize"
        [lazy]="true"
        [totalRecords]="totalCount"
        [loading]="loading">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9" class="text-center">
                {{'UserPages.UserClosedSale.NotInformationMessageText' | translate}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center">
                <p-button
                  label="{{'AssignStock.AssignLabel' | translate}}"
                  (click)="assignStock()"
                  class="custom-text-button assign-button"
                  [disabled]="!isSelectedPalletStock"/>
              </th>
              <th></th>
              <th *ngIf="appliedWithProgramName">{{'AssignStock.ProgramNameLabel' | translate}}</th>
              <th *ngIf="appliedWithPalletNumber">{{'AssignStock.PalletNumberLabel' | translate}}</th>
              <th>{{'AssignStock.SpecieLabel' | translate}}</th>
              <th>{{'AssignStock.VarietyLabel' | translate}}</th>
              <th *ngIf="appliedWithProducer">{{'AssignStock.ProducerLabel' | translate}}</th>
              <th *ngIf="appliedWithCategory">{{'AssignStock.CategoryLabel' | translate}}</th>
              <th *ngIf="appliedWithSpeciesSize">{{'AssignStock.SpeciesSizeLabel' | translate}}</th>
              <th *ngIf="appliedWithContainer">{{'AssignStock.ContainerLabel' | translate}}</th>
              <th class="text-center">{{'AssignStock.TotalPallets' | translate}}</th>
              <th class="text-center">{{'AssignStock.TotalCasesLabel' | translate}}</th>
            </tr>
          </ng-template>
          <ng-template let-group pTemplate="body" let-expanded="expanded">
            <tr>
              <td>
                  <div style="text-align: center;">
                    <p-checkbox
                    [binary]="true"
                    [(ngModel)]="selectedGroupCheck[group.groupIndex]"
                    (onChange)="toggleAllSelectableRows($event, group.groupIndex)">
                    </p-checkbox>
                  </div>
              </td>
              <td>
                <p-button
                  pRipple
                  [pRowToggler]="group"
                  styleClass="p-button-text"
                  class="custom-button-icon chevron-icon"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
              </td>
              <td *ngIf="appliedWithProgramName">{{ group.programName }}</td>
              <td *ngIf="appliedWithPalletNumber">{{ group.palletNumber }}</td>
              <td>{{ group.species }}</td>
              <td>{{ group.variety }}</td>
              <td *ngIf="appliedWithProducer">{{ group.producer }}</td>
              <td *ngIf="appliedWithCategory">{{ group.category }}</td>
              <td *ngIf="appliedWithSpeciesSize">{{ group.speciesSize }}</td>
              <td *ngIf="appliedWithContainer">{{ group.container }}</td>
              <td class="text-center">{{ group.totalPallets }}</td>
              <td class="text-center">{{ group.totalCases }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-group>
            <tr>
              <td [colSpan]="stockColumns.length + 4" class="expand-container">
                <div>
                  <p-table
                  [value]="group.palletStock"
                  selectionMode="multiple"
                  [(selection)]="selectedPalletStockMap[group.groupIndex]"
                  (onRowSelect)="onSelectRowHandler($event)"
                  [paginator]="group.palletStock.length > 5 ? true : false"
                  [rows]="5"
                  dataKey="id"
                  class="order-table">
                    <ng-template pTemplate="header" >
                      <tr>
                        <th>
                          <div class="cell-style">
                            {{'UserPalletStock.StatusLabel' | translate}}
                          </div>
                        </th>
                        <th>
                          <div class="cell-style">
                            {{'UserPalletStock.Program' | translate}}
                          </div>
                        </th>
                        <th>
                          <div class="cell-style">
                            {{'UserPalletStock.OrderId' | translate}}
                          </div>
                        </th>
                        <th *ngFor="let col of stockColumns">
                          <div class="cell-style">
                            {{ col | stockColumn }}
                          </div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">

                      <tr
                        [ngClass]="selectedGroupCheck[group.groupIndex] ? 'p-highlight' : '' ">
                          <td>
                            <div *ngIf="rowData.status === 0" class="cell-style">
                              <span class="status-text stock-not-used">
                                {{'UserPalletStock.NotUsedStatus' | translate}}
                              </span>
                            </div>
                            <div *ngIf="rowData.status === 1" class="cell-style">
                              <span  class="status-text stock-used">
                                {{'UserPalletStock.UsedStatus' | translate}}
                              </span>
                            </div>
                            <div *ngIf="rowData.status === 2" class="cell-style">
                              <span  class="status-text stock-dispatch">
                                {{'UserPalletStock.DispatchStatus' | translate}}
                              </span>
                            </div>
                          </td>
                        <td>
                          <div class="cell-style">
                            {{rowData.directSaleProgramId ? rowData.directSaleProgramId : 'UserPalletStock.NotAssigned' | translate }}
                          </div>
                        </td>
                        <td>
                          <div class="cell-style">
                            {{rowData.importOrderSequence ? rowData.importOrderSequence : 'UserPalletStock.NotAssigned' | translate }}
                          </div>
                        </td>
                        <td *ngFor="let col of stockColumns">
                           <div class="cell-style">
                             {{ rowData[col.frontEntityField] }}
                           </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
</div>

